import { gql } from '@apollo/client';

export default gql`
  subscription notificationTotalsSubscription($userId: String!) {
    notificationTotalsSubscription(userId: $userId) {
      open
      unread
    }
  }
`;
